import { PageLinkProps } from "@/components/General/PageLinks/PageLink/pageLink.component";

const rewriteAccountLinksForSoftLogin = (
    isLoggedIn: boolean,
    links?: Array<PageLinkProps>,
    loginPage?: string
): Array<PageLinkProps> | undefined => {
    if (!loginPage || isLoggedIn) return links;

    return links?.map((link) => {
        return {
            ...link,
            link: loginPage
        };
    });
};

export { rewriteAccountLinksForSoftLogin };
